import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {UserProfile} from '../models/user-profile';

@Injectable()
export class UserProfileService {

  constructor(private apiService: ApiService) {
  }

  getAllUserProfiles() {
    return this.apiService.get('Profile/GetAll').map(res => {
      if (res && res.values) {
        return res.values.map(value => new UserProfile(value));
      }
    });
  }

  getUserProfileById(id: number) {
    return this.apiService.get('Profile/' + id).map(res => {
      if (res && res.value) {
        return new UserProfile(res.value);
      }
    });
  }

  updateUserProfile(userProfile: UserProfile) {
    return this.apiService.post('Profile/Save', userProfile).map(res => {
      if (res && res.values) {
        return res.values.map(value => new UserProfile(value));
      }
    });
  }

  deleteProfile(userProfile: UserProfile) {
    return this.apiService.delete('Profile/' + userProfile.id).map(res => {
      if (res && res.values) {
        return res.values.map(value => new UserProfile(value));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user-profile.service.ts